/**
 * User: Eric Willenson
 * Date: 04/27/16
 * Time: 11:32 PM
 */

'use strict';

function hasDataClass(props = {}, requiredProps = []) {
    let hasData = true;
    requiredProps.forEach(currentProperty => {
        currentProperty = props[currentProperty];
        if (typeof currentProperty !== 'undefined') {
            hasData = currentProperty || currentProperty === false ? hasData : false;
        } else {
            hasData = false;
        }
    });
    return hasData ? '' : 'no-data';
}

module.exports = hasDataClass;



// WEBPACK FOOTER //
// ./assets/js/newPdp/helpers/componentHasDataClass.es.js